import { jsx, jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { useTranslation } from "@crehana/i18n";
import { Dropdown, DropdownContent, DropdownFilterButton, DropdownIconsList } from "../Dropdown/index.js";
import { PopperAnchor } from "../Popper/index.js";
import i18n from "./i18n/index.js";
const SelectorGenerator = ({ optionsSelector })=>{
    const [category, setCategory] = useState();
    const { languageCode } = useTranslation();
    const t = i18n[languageCode];
    const handleSelectCategory = (categoryValue)=>{
        setCategory(categoryValue);
        console.log(category, 'category');
    };
    return /*#__PURE__*/ jsx(PopperAnchor, {
        children: /*#__PURE__*/ jsx(Dropdown, {
            children: /*#__PURE__*/ jsxs("div", {
                className: "tw-w-full",
                children: [
                    /*#__PURE__*/ jsx("div", {
                        className: "tw-flex tw-items-center tw-justify-center",
                        children: /*#__PURE__*/ jsx(DropdownFilterButton, {
                            children: t.FILTERS_BUTTON_DROPDOWN
                        })
                    }),
                    /*#__PURE__*/ jsx(DropdownContent, {
                        children: /*#__PURE__*/ jsx(DropdownIconsList, {
                            className: "tw-h-full !tw-max-h-full tw-max-w-[400px]",
                            contentClassName: "tw-line-clamp-none",
                            items: optionsSelector,
                            onSelect: handleSelectCategory
                        })
                    })
                ]
            })
        })
    });
};
export { SelectorGenerator };
